export default __webpack_public_path__ + "static/media/KH.e787ce3c.svg";